import script from "./StreamThumb.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamThumb.vue?vue&type=script&setup=true&lang=js"

import "./StreamThumb.vue?vue&type=style&index=0&id=130df1f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-130df1f2"]])

export default __exports__